/* eslint-disable */
/**
 * 检查SDK是否存在，不存在则插入
 * 注：当插入mtop依赖时，则必须再执行插入一次patch文件，否则可能导致mtop默认配置发生变更（主要发生在同时初始化多个组件实例的情况）
 * @returns
 */
export function checkSDK() {
  var isLoadingMtop = false;
  function addMtopPatch(cb) {
    var scripts = Array.from(document.querySelectorAll('script'));
    var sdk = scripts.find(function (o) {
      return o.src.includes('cndzk-mtop-patch.js');
    });
    if (isLoadingMtop) {
      createScriptForPatch(cb);
      return;
    }
    if (!sdk) {
      createScriptForPatch(cb);
    } else {
      cb();
    }
  }
  function createScriptForPatch(callback) {
    var js = document.createElement('script');
    js.src = '//g.alicdn.com/cndzk-entrance/cndzk-mtop-patch/0.1.11/cndzk-mtop-patch.js';
    js.onload = function () {
      callback();
    };
    document.body.appendChild(js);
  }
  return new Promise(function (resolve) {
    var _window, _window$lib;
    var isLoadMtopLib = (_window = window) === null || _window === void 0 ? void 0 : (_window$lib = _window.lib) === null || _window$lib === void 0 ? void 0 : _window$lib.mtop;
    if (isLoadMtopLib || window.__is_load_mtop_sdk) {
      addMtopPatch(resolve);
      return;
    } else {
      isLoadingMtop = true;
      var mtopSDK = document.createElement('script');
      mtopSDK.src = '//g.alicdn.com/??mtb/lib-promise/3.1.1/polyfillB.js,mtb/lib-login/1.5.4/login.js,mtb/lib-mtop/2.5.7/mtop.js';
      mtopSDK.onload = function () {
        addMtopPatch(resolve);
        window.__is_load_mtop_sdk = true;
      };
      document.body.appendChild(mtopSDK);
    }
  });
}